import { OPERATION_METHOD } from '~/portal/types/content'

const METHOD_CSS_VAR_NAME: Record<OPERATION_METHOD, string> & Record<string, string> = {
  get: 'get',
  patch: 'patch',
  post: 'post',
  put: 'put',
  delete: 'delete',
  pub: 'pub',
  rec: 'pub',
  sub: 'sub',
  send: 'sub',
  query: 'query',
  message: 'message',
  options: 'options',
}

export const getOperationCssVar = (method: OPERATION_METHOD): string =>
  `var(--sp-method-${METHOD_CSS_VAR_NAME[method.toLowerCase()]})`
